import React from 'react';

import { ModifyPlaylistButton } from '@atlassian/ai-audio/ui/buttons';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { withFlags } from '@confluence/flags/entry-points/withFlags';

const WrappedButton = ({ flags, contentId, contentType, contentTitle }) => {
	const { cloudId } = useSessionData();

	return (
		cloudId &&
		contentType === 'page' && (
			<ModifyPlaylistButton
				cloudId={cloudId}
				contentId={contentId}
				contentType={contentType}
				title={contentTitle}
				subtle
				flags={flags}
			/>
		)
	);
};

export const FeedAudioPlaylistButton = withFlags(WrappedButton);
